<!-- 免费体验会员 banner -->
<template>
    <!-- 未领体验会员 -->
    <div v-if="bannerData" class="free-vip-banner">
        <div class="title">{{ bannerData.title }}</div>
        <div v-if="bannerData.subTitle" class="sub-title">{{ bannerData.subTitle }}</div>
        <div class="icon"></div>
        <div
            v-visually="{
                serverId: 17096,
                area: vipInfo && vipInfo.canReceiveFreeVip ? 'btn-getforfree' : 'btn-sxz-sq',
            }"
            class="btn"
            @click="handleClick"
        >{{ bannerData.btn }}</div>
    </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import {receiveVip} from '../../utils/commonReq';

export default {
    name: 'FreeVipBanner',
    data() {
        return {
            isSubmitting: false
        };
    },
    props: {
        // 副标题
        subTitle: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapState({
            userInfoNew: state => state.lawStore?.userInfoNew || {},
            vipInfo: state => state.lawStore.vipInfo
        }),
        bannerData() {
            const {canReceiveFreeVip} = this.vipInfo;
            // 能认领免费体验会员且未认领
            if (canReceiveFreeVip) {
                return {
                    title: '恭喜您获得尊享会员15天免费体验机会',
                    subTitle: this.subTitle,
                    btn: '免费领取'
                };
            }
            return null;
        }
    },
    methods: {
        ...mapActions({
            getVipInfo: 'lawStore/getVipInfo'
        }),
        ...mapMutations({
            emitEvent: 'EventBus/emitEvent'
        }),
        handleClick() {
            const {canReceiveFreeVip} = this.vipInfo;
            this.$wywLog.send({
                serverId: 17096,
                area: canReceiveFreeVip ? 'btn-getforfree' : 'btn-sxz-sq',
                action: 'click'
            });
            if (this.isSubmitting) {
                return;
            }
            this.isSubmitting = true;
            if (canReceiveFreeVip) {
                this.handleReceiveVip();
                return;
            }
        },
        // 免费体验会员领取
        handleReceiveVip() {
            receiveVip({city_level: this.userInfoNew?.lawyer_info?.city_level}).then(res => {
                this.emitEvent({name: 'global_free_vip_event', payload: {
                    dialogType: 'receive-success'
                }});
            }).finally(() => {
                this.isSubmitting = false;
            }).catch(() => {});
        }
    }
};
</script>

<style lang='less' scoped>
.free-vip-banner {
    padding: 20px 24px;
    border-radius: 8px;
    position: relative;
    height: 80px;
    background-image: linear-gradient(-56deg, #fffbec 0%, #fffbec 100%), url("https://lvlin-base.cdn.bcebos.com/fe-saas/component/free-vip-banner/%E7%94%BB%E6%9D%BF%E5%A4%87%E4%BB%BD%207.png");
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-top: 20px;

    .title {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #0b1b3e;
        line-height: 20px;
        margin-left: 191px;
        min-width: 425px;
    }

    .sub-title {
        opacity: .6;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333;
        line-height: 13px;
        margin-top: 8px;
        margin-left: 191px;
    }

    .icon {
        position: absolute;
        left: 24px;
        top: 17px;
        width: 161px;
        height: 63px;
        background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/component/free-vip-banner/huanguan.png") no-repeat center / 100% 100%;
    }

    .btn {
        background-image: linear-gradient(90deg, #ffe99e 1%, #ffdc68 100%);
        border-radius: 5px;
        width: 176px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #a54300;
        text-align: center;
        line-height: 16px;
        padding: 12px 0;
        position: absolute;
        top: 20px;
        right: 24px;
        cursor: pointer;
    }
}

.free-vip-expired-tips {
    background: #fffbec;
    padding: 20px 24px;
    height: 60px;
    display: flex;
    align-items: center;
    position: relative;
    margin-top: 20px;
    border-radius: 8px;

    .icon {
        height: 20px;
        width: 20px;
        background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/common/yellow-tip-icon.png") no-repeat center center / 100% 100%;
        flex-shrink: 0;
    }

    .content {
        margin-left: 10px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #0b1b3e;
        letter-spacing: 0;
        line-height: 14px;
    }

    .btn {
        background-image: linear-gradient(90deg, #ffe99e 1%, #ffdc68 100%);
        border-radius: 5px;
        height: 40px;
        width: 136px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #a54300;
        text-align: center;
        line-height: 40px;
        position: absolute;
        right: 24px;
        cursor: pointer;
    }
}
</style>
